import HttpRequest from './http_request';

export default class SchedulePermissionProvider extends HttpRequest {
  async employees() {
    const { data } = await this.get('/', { function: 'get-schedule-permission-employees' });
    return data;
  }
  async permissions(level_id, faculty_id) {
    const { data } = await this.get('/', { function: 'get-schedule-permissions', level_id, faculty_id });
    return data;
  }
  async add(level_id, faculty_id, users) {
    const { data } = await this.create('/', { function: 'add-schedule-permissions', level_id, faculty_id, users });
    return data;
  }
  async change(id, action) {
    const { data } = await this.create('/', { function: 'change-schedule-permission', id, action });
    return data;
  }
}
